var _circle, _circle2, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImageColorfinderPlugin = function SvgImageColorfinderPlugin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.857,
    cy: 10.857,
    r: 5.965,
    stroke: "currentColor",
    transform: "rotate(-45 10.857 10.857)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#image-colorfinder-plugin_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "image-colorfinder-plugin_svg__b",
    width: 10,
    height: 10,
    x: 6,
    y: 6,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.858,
    cy: 10.857,
    r: 4.242,
    fill: "currentColor",
    transform: "rotate(-45 10.858 10.857)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#image-colorfinder-plugin_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.1,
    d: "m4.859 10.857 6-6 5.998 6-5.999 5.999z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m14.905 15.666.762-.762 4.23 4.23-.762.762z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "image-colorfinder-plugin_svg__a",
    width: 11.484,
    height: 11.484,
    x: 5.116,
    y: 5.115,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5799_16072"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5799_16072",
    result: "shape"
  })))));
};
export default SvgImageColorfinderPlugin;